import { BASE_URL, SOMS_API_KEY, SUPPLIER_DESTINATION_MAPPING_ENDPOINT } from "services/CONSTANTS";
import { SEARCH_SUPPLIER_DESTINATION_MAPPING_FAILURE, SEARCH_SUPPLIER_DESTINATION_MAPPING_REQUEST, SEARCH_SUPPLIER_DESTINATION_MAPPING_RESET, SEARCH_SUPPLIER_DESTINATION_MAPPING_SUCCESS } from "./action-type"
import { Get } from "services/apiService";
import { FEATURE } from "components/common/CONSTANTS";

export const searchSupplierDestinationMappingAction = (payload) => {
    return (dispatch) => {
        dispatch(searchSupplierDestinationMappingRequest());
        const apiUrl = `${BASE_URL}${SUPPLIER_DESTINATION_MAPPING_ENDPOINT}?apikey=${SOMS_API_KEY}&feature=${FEATURE.D1D2}`;
        
        Get({
            url: apiUrl,
            params: payload
        })
            .then((response) => {
                if (response.status === 200) {
                    dispatch(searchSupplierDestinationMappingSuccess(response));
                } else {
                    dispatch(searchSupplierDestinationMappingFailure(response));
                }
            })
            .catch((err) => {
                dispatch(searchSupplierDestinationMappingFailure(err));
            });
    }
}

const searchSupplierDestinationMappingRequest = () => {    
    return {
        type: SEARCH_SUPPLIER_DESTINATION_MAPPING_REQUEST
    }
}

const searchSupplierDestinationMappingSuccess = (response) => {
    return {
        type: SEARCH_SUPPLIER_DESTINATION_MAPPING_SUCCESS,
        searchSupplierDestinationMappingResponse: response
    }
}

const searchSupplierDestinationMappingFailure = (error) => {
    return {
        type: SEARCH_SUPPLIER_DESTINATION_MAPPING_FAILURE,
        searchSupplierDestinationMappingResponse: error
    }
}

export const searchSupplierDestinationMappingReset = () => {
    return {
        type: SEARCH_SUPPLIER_DESTINATION_MAPPING_RESET
    }
}